import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';

export interface Port {
  id: string;
  nom: string;
  ville: string | null;
  code_postal: string | null;
  departement: string | null;
  region: string | null;
  pays: string;
  latitude: number | null;
  longitude: number | null;
  telephone: string | null;
  email: string | null;
  site_web: string | null;
  description: string | null;
  capacite_places: number | null;
  vhf_canal: string | null;
  services: string | null;
}

export const usePortSearch = (query: string, limit = 10) => {
  const [results, setResults] = useState<Port[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const q = query.trim();
    if (q.length < 2) {
      setResults([]);
      return;
    }
    let cancelled = false;
    const t = setTimeout(async () => {
      setLoading(true);
      const pattern = `%${q}%`;
      const { data, error } = await supabase
        .from('ports' as any)
        .select('*')
        .or(`nom.ilike.${pattern},ville.ilike.${pattern}`)
        .order('nom', { ascending: true })
        .limit(limit);
      if (!cancelled) {
        if (!error) setResults((data as any) || []);
        setLoading(false);
      }
    }, 200);
    return () => {
      cancelled = true;
      clearTimeout(t);
    };
  }, [query, limit]);

  return { results, loading };
};

export const useFindPortByName = (nom?: string | null) => {
  const [port, setPort] = useState<Port | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!nom) {
      setPort(null);
      return;
    }
    let cancelled = false;
    setLoading(true);
    (async () => {
      const { data } = await supabase
        .from('ports' as any)
        .select('*')
        .eq('nom', nom)
        .limit(1)
        .maybeSingle();
      if (!cancelled) {
        setPort((data as any) || null);
        setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [nom]);

  return { port, loading };
};
